/* prettier-ignore */
export const content = {
  'designer.pages.create-static-page.disabled': 'Disabled in this mode',
  'designer.pages.create-static-page.optimization-selected.disabled': 'Disabled when a variation is selected',
  'designer.pages.create-static-page.standard.label': 'Create page',
  'designer.pages.create-static-page.standalone-branch.label': 'Create page as branch',

  'designer.pages.actions.settings.disabled.site-page':
    "You can't open Page settings for this page",
  'designer.pages.actions.settings.disabled.cms-collection':
    "You can't open Collection settings for this page",

  'designer.pages.create-static-page.template.required-text': 'A page template is required to build pages',
  'designer.pages.create-static-page.template.max-reached-text': 'This site has reached the max number of {{maxPageTemplateCount}} template pages.',
  'designer.pages.create-static-page.template.label': 'Create page template',

  'designer.pages.components.page-switcher.page-settings-shortcut-button.label': 'Open page settings',
  'designer.pages.components.page-switcher.quick-access-menu.button.label': 'Page menu',
  'designer.pages.components.page-switcher.quick-access-menu.create-branch.label': 'Create page branch',
  'designer.pages.components.page-switcher.quick-access-menu.page-settings.label': 'Page settings',

  'designer.pages.create-static-page.new-aisg-page.label': 'Generate new page with AI',
  
  'designer.pages.page-settings.custom-code-info': 'Code here applies to this page only, after site-wide custom code, and goes live when published.',
  'designer.pages.page-settings.custom-code-note': 'Custom code is not validated and may cause issues when published.',
  'designer.pages.page-settings.json-ld-schema-info': 'Add schema markup to help search and answer engines understand and display your content.',
  'designer.pages.page-settings.json-ld-schema-note': "Schema is not validated and may cause issues when published. AI-generated schema is validated against schema.org but manual edits are not.",

  'designer.pages.restricted-page-badge.label': 'Restricted',
  'designer.pages.restricted-page-badge.tooltip': 'You can’t edit static content on this page',
  'designer.pages.restricted-page-badge.locale-tooltip': 'You don’t have permission to edit in this locale',

  'designer.cms.view-only-tag.collection-tooltip': "You don't have edit access to this collection",
  'designer.cms.view-only-tag.locale-tooltip': "You don't have permission to edit in this locale",

  'designer.pages.restricted-page-lock.tooltip': "You don't have edit access",
  'designer.pages.restricted-page-lock.branch-in-use.tooltip':
    "This branch is in use. You also don't have edit access",

  'designer.pages.locale-lock-indicator.page-access': 'Page access',
  'designer.pages.locale-lock-indicator.tooltip': 'You can edit this page in other locales',
  'designer.pages.locale-lock-indicator.tooltip.action': 'Click to change locales',
}
